import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { setCpdCianSource, setCpdSource, setPrelandingModalOpen } from 'shared/actions/cpd';
import { CPDAsideTrap } from 'shared/components/CPD';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { ICPDPrelandingConfig } from 'shared/containers/valuationTraps/HomeownerTrap/CPDHomeownerTrap/types';
import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';
import { ECpdPrelandingModalView } from 'shared/types/cpd/cpd';

export const CPDAsideTrapContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { trackCPDTrapVisible, trackCPDTrapClick } = useCpdTracking();

  const { config } = useApplicationContext();
  const prelandingContent = config.get<ICPDPrelandingConfig>('CPDPrelandingData');

  const onTrapClick = React.useCallback(() => {
    dispatch(setPrelandingModalOpen({ isOpen: true, modalView: ECpdPrelandingModalView.Searcher }));
    dispatch(setCpdSource('trapOfferScreenPriceBlock'));
    dispatch(setCpdCianSource('trapOfferScreenPriceBlock_web'));
    trackCPDTrapClick('trapOfferScreenPriceBlock');
  }, []);

  if (!prelandingContent?.searcher) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={() => trackCPDTrapVisible('trapOfferScreenPriceBlock')} callbackDelay={1000}>
      <CPDAsideTrap onClick={onTrapClick} />
    </ActionAfterViewObserver>
  );
};
